export default "__VITE_ASSET__Dz0L5pnf__"